import { Loading } from '@/components/Loading/Loading';

/** Full-viewport loading cover. Same box MUI's Backdrop drew here: fixed,
 *  black at 50% in both modes, on the theme's z-index 4000 (the layer
 *  ui/dialog's overlay uses, so it still sits over app chrome), fading in
 *  over Fade's 225ms. */
export const LoadingScreen = () => (
    <div
        data-loading-screen
        data-testid="loading-screen"
        aria-hidden
        className="fixed inset-0 z-[4000] flex items-center justify-center bg-black/50 motion-safe:animate-loading-screen-in"
    >
        <Loading />
    </div>
);
